module.exports = __webpack_public_path__ + "img/4.4d8471eb.jpg";